import Head from "next/head";
import { OnboardingShell } from "@medbillai/app/screens/onboarding";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { OnboardingPageTransition } from "../utils/transition/OnboardingPageTransition";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
import type { NextPageWithLayout } from "./_app";
export const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="get-started.tsx">
        <title>Get Started</title>
      </Head>
      <OnboardingShell phase="preauth" Transition={OnboardingPageTransition} data-sentry-element="OnboardingShell" data-sentry-source-file="get-started.tsx" />
    </>;
};
Page.getLayout = page => <SignUpOnboardingLayout>
    <SlidingLayout>{page}</SlidingLayout>
  </SignUpOnboardingLayout>;
export default Page;